import {ILoadedPixiAssets} from "./pixi-assets-manager.interface";
import {PixiAsset} from "./asset/pixi-asset";
import {PixiLibWrapper} from "../pixi-lib-wrapper/pixi-lib-wrapper";

export class PixiAssetsManager {
    private _allAssetsCache: Record<string, ILoadedPixiAssets> = {};

    constructor(private _pixiLibWrapper: PixiLibWrapper | null = null) {}

    private disposeAsset = (res: PixiAsset, src: string) => {
        let loadedAsset = this._allAssetsCache[src];
        // this case can happen if we call dispose twice on the same asset and that asset is the only one / last one in the loadedAsset.usedAssets array
        if (loadedAsset === undefined) {
            return;
        }
        const index = loadedAsset.usedAssets.findIndex((item) => item === res);
        if (index >= 0) {
            loadedAsset.usedAssets.splice(index, 1);
        }
        if (loadedAsset.usedAssets.length === 0) {
            this._pixiLibWrapper.unloadAsset(src);
            delete this._allAssetsCache[src];
        }
    }

    private async _loadOneAsset(src: string) {
        // 1. check in the assets array if the asset is already loaded
        let asset = this._allAssetsCache[src];
        if (!asset) {
            // 2. call PIXI.Assets.load using the wrapper function in pixi-app-creator
            asset = {
                rawAssetPromise: this._pixiLibWrapper.loadAsset(src),
                usedAssets: []
            };
            this._allAssetsCache[src] = asset;
        }
        const rawAssetData = await asset.rawAssetPromise;
        const newAsset = new PixiAsset(rawAssetData, (res) => {
            this.disposeAsset(res, src);
        });
        asset.usedAssets.push(newAsset);
        return newAsset;
    }

    // public async load<T extends string[] | Record<string, string>>(assetsUrls: T): Promise<T extends string[] ? PixiAsset[] : Record<string, PixiAsset>> {
    //     let urls = [];
    //     if (Check.isArrayOfStrings(assetsUrls)) {
    //         urls = assetsUrls;
    //     } else {
    //         urls = Object.values(assetsUrls);
    //     }
    //     const assetsPromises = urls.map(src => this._loadOneAsset(src));
    //     if (Check.isArrayOfStrings(assetsUrls)) {
    //         return Promise.all(assetsPromises);
    //     }
        
    //     const aliases = Object.keys(assetsUrls);
    //     return Promise.all(assetsPromises).then(assets => {
    //         return assets.reduce((prevValue, currentAsset, currentIndex) => {
    //             prevValue[aliases[currentIndex]] = currentAsset;
    //             return prevValue;
    //         }, {} as Record<string, PixiAsset>)
    //     });
    // }
    public async load(assetsUrls: Record<string, string>): Promise<Record<string, PixiAsset>> {
        const urls = Object.values(assetsUrls);

        const assetsPromises = urls.map(src => this._loadOneAsset(src));
        
        const aliases = Object.keys(assetsUrls);
        return Promise.all(assetsPromises).then(assets => {
            return assets.reduce((prevValue, currentAsset, currentIndex) => {
                prevValue[aliases[currentIndex]] = currentAsset;
                return prevValue;
            }, {} as Record<string, PixiAsset>)
        });
    }

}